import axios from "axios";
import { env } from "../constants/env";
import { db } from "./offlineDB";

export const syncOfflineCertifications = async (token) => {
  if (!navigator.onLine) return;

  const allCerts = await db.offlineCertifications.toArray();

  console.log("[SYNC] Checking offline certifications", allCerts);

  for (const cert of allCerts) {
    const {
      id,
      labId,
      section,
      auditorId,
      name,
      answers,
      offline,
      timestamp,
      lastSynced,
    } = cert;

    const localIsNewer =
      !lastSynced || new Date(timestamp) > new Date(lastSynced);

    if (!offline && !localIsNewer) continue;

    try {
      const payload = {
        name,
        labId,
        section,
        auditorId,
        answers,
      };

      const isOfflineId = id.startsWith("offline-");
      const isUpdate = !isOfflineId;

      const url = isUpdate
        ? `${env.kataApiUrl}/api/certification/id/${id}`
        : `${env.kataApiUrl}/api/certification/submit`;

      const method = isUpdate ? "PUT" : "POST";

      const res = await axios({
        url,
        method,
        data: payload,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const serverData = res.data.data;

      // 🔥 IMPORTANT: remove offline record if it was POSTed
      if (isOfflineId) {
        await db.offlineCertifications.delete(id);
      }

      console.log("Server data after sync:", serverData);

      // ✅ Update local DB as synced
      await db.offlineCertifications.put({
        ...serverData, // spread FIRST
        id: serverData._id, // force correct primary key
        labId: serverData.labId,
        offline: false,
        lastSynced: new Date().toISOString(),
        timestamp: Date.now(),
      });

      console.log(`[SYNC] Certification synced: ${serverData._id}`);
    } catch (err) {
      console.error(`[SYNC] Failed certification ${id}:`, err.message);
    }
  }
};
